import React from 'react';
import {Icon} from 'antd';

function FormLoading(){
    return(
        <div className={"formLoading"}>
            <p>در حال بارگیری</p>
            <Icon type={"loading"} style={{fontSize : '2em'}}/>
        </div>
    )
}

export default FormLoading;